var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _rect, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnigmaEscapesLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 529.52 133.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#8bc53f;}.cls-3{fill:#87c042;stroke:#fff;stroke-miterlimit:10;stroke-width:1.41px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.48,37.51H186.73v15.2h26.66V65H186.73V81.17h31.51V94.44H172.12V24.25h45.36Z",
    transform: "translate(-19.54 -20.75)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.09,95.69h-.38l-41.45-40.4V94.44H228.65V23H229l41.44,40.4V24.25h14.62Z",
    transform: "translate(-19.54 -20.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M313.64,94.44H299V24.25h14.6Z",
    transform: "translate(-19.54 -20.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M384.88,33.52,375.7,44.11a20.83,20.83,0,0,0-16.22-7.82c-12.9,0-21.29,9.64-21.29,23S347,82.4,360.42,82.4a20.82,20.82,0,0,0,11.64-3.53V67.51H356.89V55h29.7V86c-6.78,6.41-15.66,9.66-26.17,9.66-21.66,0-36.95-15.57-36.95-36.4S338.36,23,359.48,23C370.55,23,378.1,26.54,384.88,33.52Z",
    transform: "translate(-19.54 -20.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M469.86,94.44H455.34V64.93L434.91,95.39h-.77L413.7,64.93V94.44H399.09V23h.39l35,49.47,35-49.47h.38Z",
    transform: "translate(-19.54 -20.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M545.58,94.44h-16L525,83.55H498l-4.59,10.89H477.39L511.3,23h.38Zm-43-22.25h17.75l-8.87-21Z",
    transform: "translate(-19.54 -20.75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203,112.8H181.24v12.39h19v7h-19v13h22.29v7.39H173.22V105.41H203Z",
    transform: "translate(-19.54 -20.75)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.16,109.58l-4.24,6.62A17.87,17.87,0,0,0,241.17,112c-4.69,0-7.83,2-7.83,6.29,0,3.52,2.25,5,9.83,6.55C255,127.32,259,131.49,259,138.74c0,8.8-6.62,14.71-17.27,14.71-7.13,0-13.22-2.18-17.73-6.16l4.37-6.69A19.82,19.82,0,0,0,242,146.06c5.46,0,9-2.3,9-6.62,0-3.46-2.64-5.33-10.14-6.85-11.83-2.58-15.62-7-15.62-14,0-8.34,6.36-14.06,16-14.06A25.76,25.76,0,0,1,257.16,109.58Z",
    transform: "translate(-19.54 -20.75)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.43,111.58l-5.08,5.79a15.59,15.59,0,0,0-11.76-5.4c-9.5,0-15.86,7.13-15.86,17.08s6.36,17,15.86,17a15.4,15.4,0,0,0,12-5.64l5,5.9c-4.5,5-10.21,7.13-17,7.13-14,0-24-10.48-24-24.4,0-14.07,10-24.47,24-24.47A22,22,0,0,1,320.43,111.58Z",
    transform: "translate(-19.54 -20.75)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.36,152.62h-8.74l-3.71-8.55H351.12l-3.73,8.55h-8.73l22.22-48h.27Zm-29.48-15.16h14.25L361,121.08Z",
    transform: "translate(-19.54 -20.75)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.74,120.71c0,9.75-7.31,15.21-16.49,15.21h-9.51v16.71h-8v-47.2h17.54C432.36,105.42,439.74,110.81,439.74,120.71Zm-26-8.3v16.51h8.73c5.52,0,9.12-2.82,9.12-8.21s-3.66-8.3-9.12-8.3Z",
    transform: "translate(-19.54 -20.75)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M493,112.8H471.28v12.39h19v7h-19v13h22.28v7.39h-30.3v-47.2H493Z",
    transform: "translate(-19.54 -20.75)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.19,109.58,543,116.21A17.81,17.81,0,0,0,531.2,112c-4.7,0-7.84,2-7.84,6.29,0,3.52,2.26,5,9.83,6.55,11.82,2.51,15.87,6.68,15.87,13.93,0,8.8-6.63,14.71-17.29,14.71-7.13,0-13.22-2.18-17.71-6.16l4.37-6.69A19.77,19.77,0,0,0,532,146.07c5.45,0,9-2.31,9-6.63,0-3.46-2.63-5.33-10.14-6.85-11.81-2.58-15.61-7-15.61-14,0-8.34,6.36-14.06,16-14.06A25.77,25.77,0,0,1,547.19,109.58Z",
    transform: "translate(-19.54 -20.75)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 1.48 0 7.35 129.65 7.35 129.65 31.82 15.65 31.82 15.65 37.68 129.65 37.68 129.65 127.96 101.52 127.96 101.52 48.2 15.65 48.2 15.65 116.16 86.35 116.16 86.35 62.64 31.8 62.64 31.8 99.53 64.34 99.53 64.34 93.65 37.67 93.65 37.67 68.51 80.49 68.51 80.49 110.29 21.52 110.29 21.52 53.83 95.65 53.83 95.65 127.96 5.87 127.96 5.87 23.25 118.15 23.25 118.15 17.38 0 17.38 0 133.82 135.53 133.82 135.53 1.48 0 1.48"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 113.26,
    y: 48.2,
    width: 5.87,
    height: 67.94
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.74,35.26H189V50.45h26.66V62.77H189V78.91H220.5V92.18H174.39V22h45.35Z",
    transform: "translate(-19.54 -20.75)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M287.35,93.43H287L245.52,53V92.18H230.91V20.75h.37l41.45,40.4V22h14.62Z",
    transform: "translate(-19.54 -20.75)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.9,92.18H301.29V22H315.9Z",
    transform: "translate(-19.54 -20.75)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.13,31.26,378,41.86A20.81,20.81,0,0,0,361.74,34c-12.9,0-21.29,9.64-21.29,23s8.77,23.12,22.23,23.12a21,21,0,0,0,11.65-3.53V65.25H359.15V52.75h29.71v31c-6.78,6.41-15.67,9.66-26.18,9.66-21.67,0-37-15.57-37-36.4s14.9-36.28,36-36.28C372.81,20.75,380.36,24.29,387.13,31.26Z",
    transform: "translate(-19.54 -20.75)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.12,92.18H457.6V62.67L437.17,93.13h-.77L416,62.67V92.18H401.35V20.75h.39l35,49.47,35-49.46h.38Z",
    transform: "translate(-19.54 -20.75)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M547.83,92.18h-16l-4.6-10.89H500.29L495.7,92.18H479.65l33.91-71.42h.38Zm-43-22.25h17.75l-8.88-21Z",
    transform: "translate(-19.54 -20.75)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.62,88.4A38.32,38.32,0,1,1,87.3,50.09,38.31,38.31,0,0,1,125.62,88.4Z",
    transform: "translate(-19.54 -20.75)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M124.48,88.4A37.18,37.18,0,1,1,87.3,51.22,37.17,37.17,0,0,1,124.48,88.4Z",
    transform: "translate(-19.54 -20.75)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.66,88.4A33.36,33.36,0,1,1,87.3,55.05,33.35,33.35,0,0,1,120.66,88.4Z",
    transform: "translate(-19.54 -20.75)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.92,78.65c0,12.26-11.56,11.16-11.56,19.92v1.81H82.12v-3.2c0-11.35,11.14-11,11.14-18.38,0-3.63-2.64-5.58-6-5.58-3.62,0-5.85,2.37-6.34,5.85L70.84,77.4C72.58,69,78.22,64,87.4,64,97.24,64,103.92,70.5,103.92,78.65ZM93.33,111a6,6,0,1,1-6-6A5.84,5.84,0,0,1,93.33,111Z",
    transform: "translate(-19.54 -20.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnigmaEscapesLogoWhite);
export default __webpack_public_path__ + "static/media/Enigma_Escapes_Logo_white.57c789fb9811a03669c136fdcbd836a5.svg";
export { ForwardRef as ReactComponent };